import keyMirror from 'src/utilities/keyMirror';

export const ACTION_TYPES = keyMirror({
  NOTIFICATION_FETCH: null,
  NOTIFICATION_FETCH_SUCCESS: null,
  NOTIFICATION_FETCH_FAILED: null,

  NOTIFICATION_SUBMIT: null,
  NOTIFICATION_SUBMIT_SUCCESS: null,
  NOTIFICATION_SUBMIT_FAILED: null,

  NOTIFICATION_UPDATE_RECEIVE_MONEY_TO_RECEIVER: null,
  NOTIFICATION_UPDATE_RECEIVE_MONEY_TO_RECEIVER_SUCCESS: null,
  NOTIFICATION_UPDATE_RECEIVE_MONEY_TO_RECEIVER_FAILED: null,

  NOTIFICATION_UPDATE_LOW_BALANCE: null,
  NOTIFICATION_UPDATE_LOW_BALANCE_SUCCESS: null,
  NOTIFICATION_UPDATE_LOW_BALANCE_FAILED: null,
});
